/** @file Hierarchy key bindings (context `hierarchy`, live while focus is inside the panel). */
import type { Binding } from '@pose2d/shortcuts/types';

/** Delete asks to delete the selected bones and slots. */
export const bindings: Binding[] = [{ id: 'hierarchy.delete', keys: 'Delete', context: 'hierarchy' }];
